import { useMemo } from 'react'
import { Cell, Column } from 'react-table'

import { HomeLicensesCopyCode } from 'features/home/components/HomeLicensing/AvailableLicenses/HomeLicensesGroupsTable/HomeLicensesGroup/styles'
import { TableWithPaginationWrapper } from 'components/Table/styles'
import IntlFormattedDate from 'app/i18n/IntlFormattedDate'
import { Table } from 'components/Table'
import { LicenseType } from 'features/licenses/types'
import CopyCode from '../LicensesGroupsTable/CopyCode'
import Note from '../LicensesGroupsTable/Note'
import SelectedLicenseDescriptionCell from './SelectedLicenseDescriptionCell'
import SelectedLicenseMobile from './SelectedLicenseMobile'
import { ReclaimLicenseTableWrapper } from '../ReclaimLicenseModal/styles'
import { DASH_SYMBOL } from 'app/consts'

interface SelectedLicenseTableProps {
  license: LicenseType[]
}

/**
 * @todo localization
 */

function SelectedLicenseTable({ license }: SelectedLicenseTableProps) {
  const headers = useMemo(
    () => ({
      description: {
        label: 'Description',
        id: 'description',
      },
      code: {
        label: 'License',
        id: 'code',
      },
      orderNumber: {
        label: 'Order Number',
        id: 'orderNumber',
      },
      customerPO: {
        label: 'Purchase Order',
        id: 'customerPO',
      },
      created: {
        label: 'Created',
        id: 'created',
      },
      notes: {
        label: 'Notes',
        id: 'notes',
      },
    }),
    []
  )

  const licensesColumns: readonly Column<LicenseType>[] = useMemo(
    () => [
      {
        Header: headers.description.label,
        id: headers.description.id,
        accessor: 'description',
        Cell: (cell: Cell<LicenseType>) => (
          <SelectedLicenseDescriptionCell license={cell.row.original} />
        ),
        percentWidth: '25%',
      },
      {
        Header: headers.code.label,
        id: headers.code.id,
        accessor: 'code',
        width: 200,
        Cell: (cell: Cell<LicenseType>) => (
          <HomeLicensesCopyCode>
            <CopyCode code={cell.value} />
          </HomeLicensesCopyCode>
        ),
      },
      {
        Header: headers.orderNumber.label,
        id: headers.orderNumber.id,
        accessor: 'orderNumber',
        Cell: (cell: Cell<LicenseType>) => cell.value || DASH_SYMBOL,
      },
      {
        Header: headers.customerPO.label,
        id: headers.customerPO.id,
        accessor: 'customerPO',
        Cell: (cell: Cell<LicenseType>) => cell.value || DASH_SYMBOL,
      },
      {
        Header: headers.created.label,
        id: headers.created.id,
        accessor: 'created',
        Cell: (cell: Cell<LicenseType>) => (
          <IntlFormattedDate date={cell.value} withTime defaultReturn="-" />
        ),
      },
      {
        Header: headers.notes.label,
        id: headers.notes.id,
        accessor: 'notes',
        Cell: (cell: Cell<LicenseType>) => (
          <Note original={cell.row.original} disableEdit />
        ),
      },
    ],
    [headers]
  )

  return (
    <TableWithPaginationWrapper>
      <ReclaimLicenseTableWrapper>
        <Table<LicenseType>
          columns={licensesColumns}
          data={license}
          mobileViewComponent={SelectedLicenseMobile}
          disableSortBy
        />
      </ReclaimLicenseTableWrapper>
    </TableWithPaginationWrapper>
  )
}

export default SelectedLicenseTable
